/* global paginationNextPageNumber, paginationAvailablePagesNumber */
(function (window, document) {
  // next link element
  const nextElement = document.querySelector('.js-button-pagination');
  if (!nextElement) {
    return;
  }

  // post feed element
  const feedElement = document.querySelector('.post-feed');
  if (!feedElement) {
    return;
  }
  let ticking = false;

  function onPageLoad() {
    // append contents
    const postElements = this.response.querySelectorAll('article.post');
    postElements.forEach((item) => {
      // document.importNode is important, without it the item's owner
      // document will be different which can break resizing of
      // `object-fit: cover` images in Safari
      feedElement.appendChild(document.importNode(item, true));
      console.log(postElements);
    });

    nextElement.classList.remove('loading');
    // eslint-disable-next-line no-global-assign
    paginationNextPageNumber += 1;

    // If you are on the last pagination page, hide the load more button
    if (paginationNextPageNumber > paginationAvailablePagesNumber) {
      nextElement.classList.add('disabled');
    }

    // set next link
    const resNextElement = this.response.querySelector('link[rel=next]');
    if (resNextElement) {
      nextElement.href = resNextElement.href;
    } else {
      nextElement.classList.add('disabled');
    }
  }

  function onUpdate() {
    const xhr = new window.XMLHttpRequest();
    xhr.responseType = 'document';

    xhr.addEventListener('load', onPageLoad);

    xhr.open('GET', nextElement.href);

    // add loading class to load more button
    nextElement.classList.add('loading');
    xhr.send(null);
  }

  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(onUpdate);
    }
    ticking = false;
  }

  // OnClick Action
  nextElement.addEventListener('click', (e) => {
    e.preventDefault();
    requestTick();
  });
}(window, document));
